import { Contact, ContactType } from '@api/generated/graphql';
import {
  ContactMethodType,
  CustomerFormPrefixes,
} from '@components/CreateCustomer/components/CreateCustomerForm/CreateCustomerFormDefinitions';
import { EditFormPrefix } from '@pages/agent/InboxPage/components/ContactsDrawers/EditContactsDrawer';
import { IconNameType } from '@servicetitan/design-system';
import strings from './strings';

export const defaultContacts: ContactMethodType[] = [
  {
    type: ContactType.Phone,
    value: '',
    memo: '',
    jobRemindersEnabled: false,
    invoiceStatementNotification: false,
    marketingUpdatesEnabled: false,
  },
];

export type ContactFormPrefixes = CustomerFormPrefixes | EditFormPrefix;

export type ContactMethodProps = {
  contactMethods: Contact[];
};

interface IContactMethodOptions {
  value: ContactType;
  label: string;
  icon: IconNameType;
  phoneMasked?: boolean;
}

export const ContactMethodOptions = {
  [ContactType.Phone]: {
    label: strings.labels[ContactType.Phone],
    icon: 'phone',
  },
  [ContactType.Email]: {
    label: strings.labels[ContactType.Email],
    icon: 'email',
  },
  [ContactType.MobilePhone]: {
    label: strings.labels[ContactType.MobilePhone],
    icon: 'phone_iphone',
  },
  [ContactType.Fax]: {
    label: strings.labels[ContactType.Fax],
    icon: 'print',
    phoneMasked: true,
  },
  [ContactType.Unknown]: {
    label: strings.labels[ContactType.Unknown],
    icon: 'help',
  },
} as const;

export const contactMethodOptionsArray: IContactMethodOptions[] = Object.keys(
  ContactMethodOptions,
)
  .filter((key) => key !== ContactType.Unknown)
  .map((key) => {
    const value = key as ContactType;
    return {
      value,
      label: ContactMethodOptions[value].label,
      icon: ContactMethodOptions[value].icon,
    };
  });

export const phoneContactMethodOptionsArray: IContactMethodOptions[] =
  contactMethodOptionsArray.filter(
    (contactMethod) =>
      contactMethod.value === ContactType.Phone ||
      contactMethod.value === ContactType.MobilePhone,
  );
